module.exports = "/_next/static/images/diversification_mobile-5b5510f3fcf7fc0c6abc3395737433ad.jpeg";